import { render } from "./ConnectFanPageDialog.vue?vue&type=template&id=1196f502"
import script from "./ConnectFanPageDialog.vue?vue&type=script&lang=js"
export * from "./ConnectFanPageDialog.vue?vue&type=script&lang=js"

import "./ConnectFanPageDialog.vue?vue&type=style&index=0&id=1196f502&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__